import React from 'react';

interface ValueTagsProps<T> {
  valueArray: T[];
  handleRemoveValue: (index: number) => void;
  disable: boolean;
  getDisplayText: (value: T) => string;
}

/**
 * ValueTags
 *
 * Renders a list of tags with optional remove buttons.
 *
 * @template T
 * @param {Object} props
 * @param {T[]} props.valueArray - Array of values to display as tags.
 * @param {(index: number) => void} props.handleRemoveValue - Callback to remove a tag by index.
 * @param {boolean} props.disable - If true, disables tag removal.
 * @param {(value: T) => string} props.getDisplayText - Function to get display text for each value.
 */
const ValueTags = <T,>({ valueArray, handleRemoveValue, disable, getDisplayText }: ValueTagsProps<T>) => (
  <div className="flex flex-wrap gap-2 mb-2">
    {valueArray.map((value, index) => (
      <div
        key={index}
        onClick={!disable ? () => handleRemoveValue(index) : undefined}
        className="flex items-center gap-2 px-3 py-1 transition-colors rounded-md cursor-pointer group bg-light-grey hover:bg-muted-dark-purple hover:text-white"
      >
        <span>{getDisplayText(value)}</span>
        {!disable && (
          <button type="button" className="text-sm text-red-600 hover:text-red-800">
            ✕
          </button>
        )}
      </div>
    ))}
  </div>
);

export default ValueTags;
